import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useAuthStore } from '@/modules/Auth/store/index'

export function authGuard(
  to: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const authStore = useAuthStore()
  if (to.name !== 'login' && !authStore.isAuthenticated) next({ name: 'login' })
  else if (to.name === 'login' && authStore.isAuthenticated)
    next({ name: 'home' })
  else next()
}
